import { useCallback, useEffect, useRef, useState } from "react";
import { listEmailHistory } from "./emailHistoryApi";

/** Rows per history page. */
const PAGE_SIZE = 25;

/**
 * Owns the email-history list: paging and the status filter. Fetches are
 * race-guarded so a slower earlier request can't overwrite a newer one.
 * @returns {object} history state and actions.
 */
export function useEmailHistory() {
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchIdRef = useRef(0);

  const load = useCallback(
    (page = 1, nextStatus = status) => {
      const fetchId = ++fetchIdRef.current;
      setLoading(true);
      setError(null);
      listEmailHistory(page, PAGE_SIZE, nextStatus).then((res) => {
        if (fetchId !== fetchIdRef.current) return;
        if (res.isSuccess && res.data) {
          setRows(res.data.data || []);
          setPagination(res.data.pagination || null);
        } else {
          setError(res.message || "Failed to load email history");
        }
        setLoading(false);
      });
    },
    [status],
  );

  useEffect(() => {
    load(1, status);
  }, [load, status]);

  return { rows, pagination, status, setStatus, loading, error, load };
}
